export const TICKET_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const TICKET_IMAGE_NAME_OK = /\.(png|jpg|jpeg)$/i;

export function convertCaptureDataUriToFile(dataUri, fileName) {
  const cleanedBase64String = String(dataUri || "").replace(
    /^data:image\/[a-z]+;base64,/,
    ""
  );
  const decodedData = window.atob(cleanedBase64String);
  const byteNumbers = new Array(decodedData.length);

  for (let i = 0; i < decodedData.length; i += 1) {
    byteNumbers[i] = decodedData.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "image/jpeg" });

  return new File([blob], fileName, { type: "image/jpeg" });
}

export function buildTicketCaptureFileName() {
  return `ticket_capture_${Date.now()}.jpg`;
}

export function buildScanCaptureFileName() {
  return `scan_${Date.now()}.png`;
}

export function pickValidTicketImageFiles({
  rawFiles,
  remainingSlots,
  onInvalidFormat,
  onInvalidSize,
  onMaxExceeded,
}) {
  const raw = Array.from(rawFiles || []);

  if (raw.length === 0) {
    return [];
  }

  if (remainingSlots <= 0) {
    onMaxExceeded?.();
    return [];
  }

  if (raw.length > remainingSlots) {
    onMaxExceeded?.();
  }

  const next = raw.slice(0, remainingSlots);

  for (let i = 0; i < next.length; i += 1) {
    const file = next[i];

    if (!TICKET_IMAGE_NAME_OK.test(file.name)) {
      onInvalidFormat?.();
      return null;
    }

    if (file.size > TICKET_IMAGE_MAX_BYTES) {
      onInvalidSize?.();
      return null;
    }
  }

  return next;
}
